(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fp-stock"] && !Shopify.designMode) return;
  try {
    (() => {
    const source = document.getElementById('FpStockSource');
    const main = document.getElementById('MainContent');
    if (!source || !main) return;

    const templates = new Map(
      Array.from(source.querySelectorAll('template[data-fp-stock-template]'),
        template => [template.dataset.fpStockTemplate, template])
    );
    const placements = new WeakMap();
    let frame = 0;

    function showStock(owner, anchor, variantId, useFallback = false) {
      let label = placements.get(owner);
      const key = templates.has(String(variantId)) ? String(variantId) : (useFallback ? 'unknown' : '');
      const template = templates.get(key);
      if (!template || !anchor) {
        if (label) label.hidden = true;
        return;
      }
      if (!label || !label.isConnected) {
        label = document.createElement('div');
        label.className = 'fp-stock';
        label.setAttribute('role', 'status');
        label.setAttribute('aria-live', 'polite');
        label.setAttribute('aria-atomic', 'true');
        anchor.before(label);
        placements.set(owner, label);
      }
      if (label.dataset.fpStockVariant !== key) {
        label.replaceChildren(template.content.cloneNode(true));
        label.dataset.fpStockVariant = key;
      }
      label.hidden = false;
    }

    function renderStock() {
      frame = 0;
      main.querySelectorAll('.fp-card, .cf-card').forEach(card => {
        const input = card.querySelector('input[name="id"], select[name="id"]');
        const button = card.querySelector('[data-fp-variant]');
        const variantId = input?.value || button?.dataset.fpVariant || card.id.replace(/^fp-card-/, '');
        const anchor = card.querySelector('.fp-actiuni, form[data-cf-form]');
        showStock(card, anchor, variantId, true);
        const template = templates.get(String(variantId));
        const buttonToSync = card.querySelector('form.fp-actiuni .fp-buton');
        if (template && buttonToSync && buttonToSync.dataset.fpStockSynced !== String(variantId)) {
          const label = buttonToSync.textContent.trim();
          if ([source.dataset.fpAddLabel, source.dataset.fpEmptyLabel].includes(label)) {
            const available = template.dataset.fpAvailable === 'true';
            buttonToSync.disabled = !available;
            buttonToSync.textContent = available ? source.dataset.fpAddLabel : source.dataset.fpEmptyLabel;
            if (available && buttonToSync.type === 'button') buttonToSync.type = 'submit';
            card.querySelectorAll('.fp-badge-epuizat').forEach(badge => { badge.hidden = available; });
            buttonToSync.dataset.fpStockSynced = String(variantId);
          }
        }
      });
      main.querySelectorAll('[id^="MainProduct-"] product-form form[action*="/cart/add"]').forEach(form => {
        if (form.closest('.fp-card, .cf-card')) return;
        const input = form.querySelector('[name="id"]');
        showStock(form, form.closest('product-form'), input?.value);
      });
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(renderStock);
    }

    main.addEventListener('change', schedule);
    main.addEventListener('click', event => {
      if (event.target.closest('[data-variant-id], [data-fp-corr], #fp-sortare')) schedule();
    });
    new MutationObserver(records => {
      if (records.some(record => {
        if (record.target.closest?.('.fp-stock')) return false;
        if (record.type === 'attributes') {
          return record.target.matches('[name="id"], [data-variant-id]');
        }
        return Array.from(record.addedNodes).some(node =>
          node.nodeType === 1 && !node.matches('.fp-stock, .fp-stock *') &&
          (node.matches('.fp-card, .cf-card, form, product-form') ||
           node.querySelector('.fp-card, .cf-card, form, product-form'))
        );
      })) schedule();
    }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class'] });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    renderStock();
  })();
  } catch(e) { console.error(e); }
})();

})();
